import React from 'react';
import { Modal, Button, Form, Select } from 'antd';
import { angsuranOptions, jenisPembayaranOptions } from '../../../../../data/options';

const { Option } = Select;

class Filter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},
            loading: false,
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    render() {

        return (
            <Modal
                title="Filter"
                width={300}
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Tutup</Button>
                    <Button type='primary' onClick={this.props.setTableFilterFromTemp}>Terapkan</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    
                    <Form.Item label="Jenis Pembayaran">
                        <Select
                            allowClear
                            name="jenis_pembayaran"
                            placeholder="Jenis Pembayaran"
                            onChange={(e, newValue) => {
                                this.props.setTempTableFilter("jenis_pembayaran", newValue ? newValue.value : null)
                            }}
                            style={{ width: '100%' }}
                        >
                            {jenisPembayaranOptions.map((row, i) => <Option key={i} value={row.value}>{row.label}</Option>)}
                        </Select>
                    </Form.Item>
                    
                    <Form.Item label="Angsuran">
                        <Select
                            allowClear
                            name="angsuran"
                            placeholder="Angsuran"
                            onChange={(e, newValue) => {
                                this.props.setTempTableFilter("angsuran", newValue ? newValue.value : null)
                            }}
                            style={{ width: '100%' }}
                        >
                            {angsuranOptions.map((row, i) => <Option key={i} value={row.value}>{row.label}</Option>)}
                        </Select>
                    </Form.Item>
                </Form >
            </Modal >
        )
    }
}

export default Filter;
